import "./AboutPage.css";


const AboutPage = () => {
    return(
        <h2>Marielle is een....</h2>
    )
}
export default AboutPage;